import { LogEntriesCatalogCombinedProps } from './types';

const usePresenter = (props: LogEntriesCatalogCombinedProps): LogEntriesCatalogCombinedProps => {
  return props;
};

export default usePresenter;
